export const RATING_COLOR_1 = 'rgba(205, 28, 38, 1)';
export const RATING_COLOR_2 = 'rgba(255, 120, 0, 1)';
export const RATING_COLOR_3 = 'rgba(191, 199, 19, 1)';
export const RATING_COLOR_4 = 'rgba(91, 168, 41, 1)';
export const RATING_COLOR_5 = 'rgba(48, 93, 2, 1)';
